import { DisableTaskersCardShared } from '@scale/genai-compass-shared/cards/disable_taskers';
import { makeAutoOpsCardUI } from '../constants';
import { faUserXmark } from '@fortawesome/pro-solid-svg-icons';

export const DisableTaskersCardUI = makeAutoOpsCardUI(DisableTaskersCardShared, {
  button: { icon: faUserXmark },
  ownerTeam: 'Allocation',
});
